import { render, staticRenderFns } from "./ConvitesCancelados.vue?vue&type=template&id=fb9c980c&scoped=true"
import script from "./ConvitesCancelados.vue?vue&type=script&lang=js"
export * from "./ConvitesCancelados.vue?vue&type=script&lang=js"
import style0 from "./ConvitesCancelados.vue?vue&type=style&index=0&id=fb9c980c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9c980c",
  null
  
)

export default component.exports